import { PayloadAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";

import { IChatbotPublic } from "../../../Components/ChatbotPublic/IChatbotPublic";
import api from "../../Axios/middleware";
import { failureChatWithElliot, successChatWithElliot } from "./ChatwithElliot";

const ChatbotWithElliotApi = (action: PayloadAction<IChatbotPublic>) => {
  return api.post("/api/dashboard/ai/chat", action.payload);
};

export function* ChatbotWithElliotCall(action: PayloadAction<IChatbotPublic>) {
  try {
    const respons: AxiosResponse = yield call(ChatbotWithElliotApi, action);
    yield put(successChatWithElliot(respons.data));
  } catch (error) {
    yield put(failureChatWithElliot(error));
  }
}
